export default __webpack_public_path__ + "static/asl-logo-16a533b37a68696bc94c423513602981.png";